import React from 'react';
import { observer } from 'mobx-react';
import { BlueprintsNavigation } from '../shared/blueprints-navigation';
import { hasPermission } from '../../../infrastructure/utils/has-permissions';
import { Permission } from '../../../api/roles.dao';
import { FormattedMessage, useIntl } from 'react-intl';
import DefaultButton from '../../global/default-button/default-button';
import { ITheadSort, ListLayout } from '../../global/tables/table-list-layout';
import { TGetReportsSortKeys } from '../../../api/reports.dao';
import TableLoadingRow from '../../global/tables/table-loading-row';
import { EventBlueprintsVM } from './event-blueprints.viewmodel';
import './event-blueprints.scss';
import BluePrintItemDetailsPopover from '../blueprint-item-details-popover/blueprint-item-details-popover';
import { EventBlueprintListItem } from './event-blueprints-list-item/event-blueprint-list.item';
import { DESCRIPTION } from '../../../constants/common-labels.constants';

type Props = {
    vm: EventBlueprintsVM;
};
export const EventBlueprintsPresentation = observer((props: Props): JSX.Element => {
    const intl = useIntl();

    const { vm } = props;

    const isListEmpty = !vm.isLoading && !vm.eventBlueprints.length;


    const tHeads: ITheadSort<TGetReportsSortKeys>[] = [
        {
            title: intl.formatMessage({
                id: 'oe.blueprints.name',
                defaultMessage: 'Name',
                description: 'Label text'
            }),
        },
        {
            title: intl.formatMessage({
                id: 'oe.blueprints.dateCreated',
                defaultMessage: 'Date Created',
                description: 'Label text'
            }),
        },
        {
            title: intl.formatMessage(DESCRIPTION),
        },
        {
            width: '150px'
        },
    ];

    return (
        <div className='event-blueprints'>
            <section className='horizontal-row horizontal-row--with-bottom-margin event-tabs'>
                <BlueprintsNavigation />
                <div className='horizontal-row__align-to-row-end'>
                    <div className='buttons-block'>
                        {hasPermission(Permission.CREATE_EVENT_BLUEPRINTS) &&
                            <DefaultButton
                                modifier={['fat', 'confirm-safe']}
                                text={
                                    <FormattedMessage
                                        id='oe.blueprints.newEventBlueprint'
                                        defaultMessage='+ New Event Blueprint'
                                        description='Button label'
                                    />
                                }
                                onClick={vm.openCreateBlueprintForm.bind(vm)}
                            />
                        }
                    </div>
                </div>
            </section>
            <section className='fixed-list-layout'>
                <div>
                    <ListLayout sortOptions={{ theads: tHeads }}>
                        {vm.isLoading && <TableLoadingRow colSpan={tHeads.length} />}
                        {isListEmpty &&
                            <tr>
                                <td className='table-loading' colSpan={tHeads.length}>
                                    <FormattedMessage
                                        defaultMessage='No Event Blueprints have been created in this account.'
                                        id='oe.blueprints.noEventBlueprints'
                                        description='Placeholder text'
                                    />
                                </td>
                            </tr>
                        }
                        {!vm.isLoading && vm.eventBlueprints.map(item => {
                            return <EventBlueprintListItem
                                key={item.blueprintId}
                                item={item}
                                isSelected={vm.isTemplatSelected(item.blueprintId)}
                                openEditModal={vm.editBlueprint.bind(vm, item.blueprintId)}
                                intl={intl}
                                openTemplateDetails={vm.openEventTemplateDetails}
                            />;
                        })}
                    </ListLayout>
                </div>
            </section>
            <BluePrintItemDetailsPopover
                title={intl.formatMessage({
                    id: 'oe.blueprint.details.viewEventBlueprintDetails',
                    defaultMessage: 'View Event Blueprint Details',
                    description: 'Popover title'
                })}
                template={vm.selectedTemplate}
                closePopover={vm.closeBluePrintItemDetailsPopover}
            />
        </div>
    );
});
